const listArr = [{
        path: '/index',
        name: 'index',
        component: () =>
            import ('@/pages/navPages/home/index.vue'),
        meta: {
            title: 'WETRUE',
            isLogin: true,
            isKeeplive: true,
            zIndex: 2
        },
    }, {
        // ad热度榜
        path: '/adRankList',
        name: 'adRankList',
        meta: {
            title: '短剧热度榜',
            isLogin: true,
            isKeeplive: true,
            zIndex: 3,
        },
        component: () =>
            import ('@/pages/navPages/adRankList.vue'),
    }, {
        // mcn热度榜
        path: '/actorRankList',
        name: 'actorRankList',
        meta: {
            title: '演员星耀榜',
            isLogin: true,
            isKeeplive: true,
            zIndex: 3,
        },
        component: () =>
            import ('@/pages/navPages/actorRankList.vue'),
    }, {
        // 端原生播放榜
        path: '/playRankList',
        name: 'playRankList',
        meta: {
            title: '端原生播放榜',
            isLogin: true,
            isKeeplive: true,
            zIndex: 3,
        },
        component: () =>
            import ('@/pages/navPages/playRankList.vue'),
    }, {
        // 快手短剧榜
        path: '/ksRankList',
        name: 'ksRankList',
        meta: {
            title: '快手短剧榜',
            isLogin: true,
            isKeeplive: true,
            zIndex: 3,
        },
        component: () =>
            import ('@/pages/navPages/ksRankList.vue'),
    }, {
        //品牌榜
        path: '/brandRankList',
        name: 'brandRankList',
        meta: {
            title: '短剧品牌榜',
            isLogin: true,
            isKeeplive: true,
            zIndex: 3,
        },
        component: () =>
            import ('@/pages/navPages/brandRankList.vue'),
    }, {
        // 女演员短剧榜
        path: '/grilActorRankList',
        name: 'grilActorRankList',
        meta: {
            title: '女演员短剧榜',
            isLogin: true,
            isKeeplive: true,
            zIndex: 3,
        },
        component: () =>
            import ('@/pages/navPages/grilActorRankList.vue'),
    }, {
        // 男演员短剧榜
        path: '/manActorRankList',
        name: 'manActorRankList',
        meta: {
            title: '男演员短剧榜',
            isLogin: true,
            isKeeplive: true,
            zIndex: 3,
        },
        component: () =>
            import ('@/pages/navPages/manActorRankList.vue'),
    }, {
        // hot 找热剧
        path: '/hotRankList',
        name: 'hotRankList',
        meta: {
            title: '找热剧',
            isLogin: true,
            isKeeplive: true,
            zIndex: 3,
        },
        component: () =>
            import ('@/pages/navPages/hotRankList.vue'),
    }, {
        // company 找发行找公司
        path: '/company',
        name: 'company',
        meta: {
            title: '找公司',
            isLogin: true,
            isKeeplive: true,
            zIndex: 3,
        },
        component: () =>
            import ('@/pages/navPages/company.vue'),
    }, {
        // aweme 素材榜
        path: '/awemeRankList',
        name: 'awemeRankList',
        meta: {
            title: '找素材',
            isLogin: true,
            isKeeplive: true,
            zIndex: 3,
        },
        component: () =>
            import ('@/pages/navPages/awemeRankList.vue'),
    }, {
        // animation 漫剧
        path: '/animation',
        name: 'animation',
        meta: {
            title: '找漫剧',
            isLogin: true,
            isKeeplive: true,
            zIndex: 3,
        },
        component: () =>
            import ('@/pages/navPages/animation.vue'),
    }, {
        path: '/hotDramaDetail',
        name: 'hotDramaDetail',
        component: () =>
            import ('@/pages/detail/hotDramaDetail.vue'),
        meta: {
            title: '短剧详情',
            isKeeplive: false,
            isLogin: true,
            zIndex: 4,
        },
    }, {
        path: '/companyDetail',
        name: 'companyDetail',
        component: () =>
            import ('@/pages/detail/companyDetail.vue'),
        meta: {
            title: '公司详情',
            isKeeplive: false,
            isLogin: true,
            zIndex: 4,
        },
    }, {
        path: '/actorDetail',
        name: 'actorDetail',
        component: () =>
            import ('@/pages/detail/actorDetail.vue'),
        meta: {
            title: '演员详情',
            isKeeplive: false,
            isLogin: true,
            zIndex: 4,
        },
    }, {
        path: '/filingService',
        name: 'filingService',
        component: () =>
            import ('@/pages/navPages/filing/filingService.vue'),
        meta: {
            title: '备案服务',
            isLogin: true,
            isKeeplive: false,
            zIndex: 5
        },
    }, {
        path: '/userinfo',
        name: 'userinfo',
        meta: {
            title: 'WETRUE',
            isLogin: true,
            isKeeplive: false,
            zIndex: 7,
        },
        component: () =>
            import ('@/pages/userInfo/userInfo.vue'),
    }, {
        path: '/myCollect',
        name: 'myCollect',
        meta: {
            title: '我的收藏',
            isLogin: true,
            isKeeplive: false,
            zIndex: 7,
        },
        component: () =>
            import ('@/pages/userInfo/myCollect.vue'),
    },
    {
        path: '/myOrder',
        name: 'myOrder',
        meta: {
            title: '我的订单',
            isLogin: true,
            isKeeplive: false,
            zIndex: 7,
        },
        component: () =>
            import ('@/pages/userInfo/myOrder.vue'),
    }
    // {
    //   path: '/werelax',
    //   name: 'werelax',
    //   component: () => import('@/pages/navPages/wetelax/index.vue'),
    //   meta: {
    //     title: 'werelax',
    //     isLogin: true,
    //     isKeeplive: true,
    //     zIndex: 2
    //   },
    // }
];
export default listArr;


// WEBPACK FOOTER //
// ./src/router/list.js